<template>
    <div class="area">
        <div>
            <div class="gameRecordTitle">{{$t('gameRecord.title')}}</div>
            <div class="textOne">{{$t('gameRecord.text1')}}</div>

            <el-form ref="form" :model="form">
                <div style="display: flex;">
                    <div class="inputWidth">
                        <el-form-item :label="$t('gameRecord.text2')">
                            <el-select v-model="form.region" :placeholder="$t('gameRecord.text3')">
                                <el-option v-for="(item,index) in gameList" :key="index" :label="item.vendorName" :value="item.vendorCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div style="margin-left:12px;">
                        <el-form-item :label="$t('gameRecord.text4')">
                            <div class="inputWidth inputMar">
                                <el-input class="inputLeft" v-model="form.betAmountMin" placeholder="0"></el-input>
                            </div>
                            <el-col class="line" :span="1"></el-col>
                            <div class="inputWidth inputMar">
                                <el-input class="inputLeft" v-model="form.betAmountMax" placeholder="0"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                </div>

                <el-form-item :label="$t('gameRecord.text5')" class="record">
                    <div class="inputWidth">
                        <el-date-picker
                            type="date"
                            :editable="false"
                            :placeholder="$t('record.text1')"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            v-model="form.startTimeBet"
                            style="width: 100%;"></el-date-picker>
                    </div>
                    <el-col class="line" :span="1"></el-col>
                    <div class="inputWidth">
                        <el-date-picker
                            type="date"
                            :editable="false"
                            :placeholder="$t('record.text1')"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            v-model="form.endTimeBet"
                            style="width: 100%;"></el-date-picker>
                    </div>
                    <div class="button">
                        <span class="query" @click="query(1)">{{$t('record.text2')}}</span>
                        <span class="reset" @click="reset">{{$t('record.text3')}}</span>
                    </div>
                </el-form-item>

            </el-form>


            <el-table :data="tableData" style="width: 100%" v-show="tableData.length > 0" height="360">
                <el-table-column prop="betNo" :label="$t('gameRecord.text6')" align="center" :resizable="false">
                    <template slot-scope="scope">
                        <div style="display:flex;">
                            <el-button
                            v-clipboard:copy="scope.row.betNo"
                            v-clipboard:success="(type) => onCopyResult('success')"
                            v-clipboard:error="(type) => onCopyResult('error')"
                            class="copybutton">{{$t('gameRecord.text7')}}</el-button>
                            <el-tooltip effect="dark" :content="scope.row.betNo" placement="top-start">
                                <p class="betNo">{{ scope.row.betNo }}</p>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="vendorName" :label="$t('gameRecord.text8')" align="center"></el-table-column>
                <el-table-column prop="gameName" :label="$t('gameRecord.text9')" align="center"></el-table-column>
                <el-table-column prop="createdAt" :label="$t('gameRecord.text10')" align="center" width="160"></el-table-column>
                <el-table-column prop="payoutTime" :label="$t('gameRecord.text11')" align="center" width="160"></el-table-column>
                <el-table-column prop="betAmount" :label="$t('gameRecord.text12')" align="center"></el-table-column>
                <el-table-column prop="betAmountValid" :label="$t('gameRecord.text13')" align="center"></el-table-column>
                <el-table-column prop="payoff" :label="$t('gameRecord.text14')" align="center"></el-table-column>
                <el-table-column prop="winLoss" :label="$t('gameRecord.text15')" align="center"></el-table-column>
            </el-table>

            <div class="null" v-show="tableData.length === 0" style="height: 360px;max-height: 360px;">
                <img loading="lazy" class="nullImg" v-lazy="require('../../../assets/images/xf/null.png')" alt="">
                <p class="nullText">{{$t('record.text4')}}</p>
            </div>

            <div class="borderBottom"></div>

            <div class="summary">
                <div class="summaryLeft">
                    <div>
                        <span>{{$t('gameRecord.text16')}}</span>
                        <span class="amountColor">￥{{totalBet}}</span>
                    </div>
                    <div style="margin-top:15px;">
                        <span>{{$t('gameRecord.text17')}}</span>
                        <span class="amountColor">￥{{distributed}}</span>
                    </div>
                </div>
                <div class="summaryRight">
                    <div>
                        <span>{{$t('gameRecord.text18')}}</span>
                        <span class="amountColor">￥{{effective}}</span>
                    </div>
                    <div style="margin-top:15px;">
                        <span>{{$t('gameRecord.text19')}}</span>
                        <span class="amountColor">￥{{profit}}</span>
                    </div>
                </div>
            </div>

            <div class="pagination">
                <el-pagination small layout="prev, pager, next" :pageSize="10" @current-change="query" :total="total" :current-page.sync="currentPage"></el-pagination>
            </div>

        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            key: 'value',
            form: {
                betAmountMin: '',
                betAmountMax: '',
                startTimeBet: '',
                endTimeBet: '',
                pageSize: 10,
                pageNum: 1,
                vendorCodeList: [],
                region: '',
                memberId: this.$common.getUser() ? this.$common.getUser().user_id : '',
            },
            gameList: [],
            totalBet: '0.00',
            effective: '0.00',
            distributed: '0.00',
            profit: '0.00',
            total:1,
            currentPage:1,
            tableData: [],
        }
    },
    created() {
        this.getGameListData();
        this.query(1);
    },
    methods: {
        // 复制
        onCopyResult(type) {
            if (type === 'success') {
                this.$message({
                    message: this.$t('record.text5'),
                    type: 'success',
                })
            } else {
                this.$message({
                    message: this.$t('record.text6'),
                    type: 'error',
                })
            }
        },
        // 请求数据
        query(val) {
            let that = this;
            let data = {...that.form};
            data.vendorCodeList = [];
            data.region?data.vendorCodeList.push(data.region):'';
            data.startTimeBet?data.startTimeBet = `${data.startTimeBet} 00:00:00`:'';
            data.endTimeBet?data.endTimeBet = `${data.endTimeBet} 23:59:59`:'';

            data.pageNum = val;
            that.currentPage = val;
            that.$http.post(that.$api.query, data, true).then((res) => {
                if (res.data) {
                    that.totalBet = that.$common.setNumFixed(Math.abs(res.data.totalBetAmount), 2);
                    that.effective = that.$common.setNumFixed(res.data.totalBetAmountValid, 2);
                    that.distributed = that.$common.setNumFixed(res.data.totalPayoff, 2);
                    that.profit = that.$common.setNumFixed(that.distributed - that.totalBet, 2);
                    if(res.data.total > 0){
                        res.data.list.map((item) => {
                            item.createdAt = that.$common.conversionTime(item.betTime);
                            item.payoutTime = item.status == 0 ? '待结算': that.$common.conversionTime(item.payoutTime);
                            item.betAmountValid = that.$common.setNumFixed(item.betAmountValid, 2);
                            item.payoff = that.$common.setNumFixed(item.payoff, 2);
                            item.winLoss? that.$common.setNumFixed(item.winLoss, 2):item.winLoss = '0.00';
                            if (item.status == 0) {
                                item.payoff = '--';
                                item.winLoss = '--';
                                item.betAmountValid = '--'
                            }
                        });
                        that.tableData = res.data.list;
                        if (res.data.total > 10) {
                            that.total = res.data.total;
                        } else {
                            that.total = 0;
                        }
                    }else{
                        that.tableData = [];
                        that.total = 0;
                    }
                }else{
                    that.tableData = [];
                    that.total = 0;
                }
            });
        },
        reset() {
            this.form.betAmountMin = '';
            this.form.betAmountMax = '';
            this.form.startTimeBet = '';
            this.form.endTimeBet = '';
            this.form.region = '';
            this.form.vendorCodeList = [];
        },
        // 获取游戏平台列表数据
        getGameListData() {
            this.$http.get(this.$api.platform).then((res) => {
                if (res) {
                    this.gameList = res.data;
                    this.gameList.unshift({
                        'vendorCode': '捕鱼',
                        'vendorId': 9999,
                        'vendorName': '捕鱼',
                    });
                }
            });
        },
    },
}
</script>


<style lang="scss" scoped>
@import url('./record.css');
.el-form-item{
    margin-bottom: 37px;
}
.selectIcon{
    width: 0;   
    height: 0;  
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 10px solid #000000;
    position: absolute;
    right: 10px;
    top: 23%;
    pointer-events: none;
}
.line{
    width: 20px;
    height: 1px;
    border-top: 1px solid #313131;
    margin: 0 10px;
}

.copybutton {
    border: none;
    color:#E91919;
    background: none;
    padding: 0 5px;
    font-size: 0.14rem !important;
    padding-top: 0.02rem;

}
.betNo{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 1.3rem;
    font-size: 0.14rem !important;
}
.borderBottom{
    height: 1px;
    background: #CDD8E0;
    margin-top: 23px;
}

.summary{
    display: flex;
    color: #313131;
    font-size: 14px;
    margin-top: 10px;
    font-weight: 400;
    .summaryRight{
        margin-left: 50px;
    }
    .amountColor{
        color: #E91919;
        margin-top: 10px;
    }
}

.pagination{
    width: 100%;
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
}
</style>